import { createAsyncThunk, createSlice, createAction } from "@reduxjs/toolkit"
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';
import { id } from "date-fns/locale";
import { tagSelectors } from 'Core/realtime/redux/tagSlice';

//import { resetALL } from '../../../../../../../.globals/redux/actions';

import moment from "moment";

//STATE INITIAL
const INIT_STATE = {
    loading: false,
    forms: [],
    error: null,
    openAdvancedFilters: false,
    filters: {
        openSearch: "",
        sortBy: "name",
        tagIds: [],
        dateRange: {
            start: moment().subtract(7, 'days').startOf('day').toDate(),
            end: moment.max(moment()).endOf('day').toDate()
        },
        limit: 10,
        offset: 0,
    }
};

const route = 'src/modules/account/views/tags/components/createEditTag/redux/slice'


export const createEditSearchDynamicForms = createAsyncThunk('dynamicForms/main/searchDynamicForms', async ({ limit, offset, openSearch, status, tagIds, sortBy, dateRange }, { rejectWithValue, dispatch, getState }) => {
    try {
        const state = getState();
        const tags = tagSelectors.selectAll(state) || [];

        let conditions = [];
        let sort = [];
        let newStatus = "";
        if (status === 1) {
            newStatus = "active";
        } else if (status === 0) {
            newStatus = "inactive";
        }

        if (newStatus) {
            conditions.push({
                fields: ["formStatus"],
                terms: [newStatus],
                exact: true
            });
        }

        let condition = {};
        if (openSearch) {
            condition = {
                fields: ["name", "description"],
                terms: [openSearch],
                exact: false
            }
        }

        // if (dateRange?.start && dateRange?.end) {
        //     condition['range'] = {
        //         fields: ["createdOn"],
        //         GTE: dateRange?.start,
        //         LTE: dateRange?.end
        //     }
        // }

        if (condition?.fields || condition?.range) {
            conditions.push(condition);
        }

        if (tagIds?.length) {
            conditions.push({
                fields: ["tagIds"],
                terms: tagIds,
                exact: true
            });
        }

        // if (sortBy) {
            sort.push({
                field: "name",
                order: "ASC"
            })
        // }


        const response = await clientQuery(
            `
            query searchDynamicForms ($conditions: [DynamicFormSearchInput], $sort: [DynamicFormSortInput], $limit: Int, $offset: Int) {
                dynamicForms: searchDynamicForms (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        name
                        tagIds
                    }
                    total
                }
            }
            `,
            {
                conditions,
                sort,
                limit, 
                offset
            },
            endpoints.GRAPHQL_GENERAL_V2
        );

        if (!response?.dynamicForms) {
            throw 'Error while getting dynamic forms';
        }

        const enrichedForms = response?.dynamicForms?.items?.map(form => {
            let formTagsArray = [];
            form.tagIds?.map(tagId => {
                const tag = tags.find(tag => tag.id == tagId);
                if(tag){
                    formTagsArray.push({
                        id: tag.id,
                        name: tag?.name,
                        color: tag?.color
                    });
                }
                
            }) || [];
            
            return {
                ...form,
                tags: formTagsArray
            };
        });
        
        return enrichedForms || [];
        
    } catch (exc) {
        ExceptionManager(exc, route, 'createEditSearchDynamicForms');
        return rejectWithValue(exc)
    }
});


const createEditTagSlice = createSlice({
    name: 'dynamicForms/list',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(createEditSearchDynamicForms.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(createEditSearchDynamicForms.fulfilled, (state, action) => {
            state.loading = false;
            state.forms = action?.payload;
            state.filters = action?.meta?.arg;
        })
        builder.addCase(createEditSearchDynamicForms.rejected, (state, action) => {
            state.loading = false;
            state.forms = [];
            state.error = action.payload;
        })
    },
})

// Extract and export the action creators object and the reducer
export const { actions, reducer } = createEditTagSlice;

// Extract and export each action creator by name
export const { reset } = actions;

//Simple async action

// Export the reducer, either as a default or named export
export default reducer;